<template>
	<div id="app">
		<div class='audios' :class='{animateRotates:isaudioPlay}' >
			<div class='audiosIm' @click='audioPause'></div>
			<audio id='myAudio' :src="imgUrls+'children_newsoul.mp3'"  controls="controls" loop="loop" autoplay></audio>
		</div>
		
		<transition :name="transitionName">
			<keep-alive :include="keepAlive">
				<router-view class="Router" id='Router'></router-view>
			</keep-alive>
		</transition>
	</div>
</template>

<script>
	import util from '@/assets/js/util.js'
	import mainRouter from '@/router/mainRouter.js' //报题模块
	export default {
		name: 'App',
		data() {
			return {
				imgUrls: this.$imgUrls,
				keepAlive: 'main-keep-alive', //需要缓存的页面 例如首页
				transitionName: 'slide-right', //初始过渡动画方向
				istoDay: (new Date).valueOf(),
				
				audioCtx: null,
				isaudioPlay: false
			}
		},
		created() {		

			 	
		},
		watch: {
			$route(to, from) {
				let _this = this;
				// 切换动画
				let isBack = this.$router.isBack // 监听路由变化时的状态为前进还是后退
				if (isBack) {
					this.transitionName = 'slide-left'
				} else {
					this.transitionName = 'slide-right'
				}
				this.$router.isBack = false;
		
			}
		},
		mounted() {
			let _this = this;
			this.$nextTick(function(){
				document.addEventListener('WeixinJSBridgeReady', () => {
					document.getElementById('myAudio').play();
					_this.isaudioPlay = true
				}, false)		
			})		
			
		},
		methods: {
			audioPause() {
				let myAudio = document.getElementById('myAudio');
				if (this.isaudioPlay) {
					myAudio.pause();
					this.isaudioPlay = false
				} else {
					myAudio.play();
					this.isaudioPlay = true
				}
			},
		},
		beforeDestroy(){
			let myAudio = document.getElementById('myAudio');
			if (this.isaudioPlay) {
				myAudio.pause();
				this.isaudioPlay = false
			}		
		}
	}
</script>

<style lang="scss">
	body,
	html {
		font-family: 'Microsoft YaHei';
		overflow-x: hidden;
	}

	#app {
		width: 10rem;
		margin: auto;
		font-family: 'Microsoft YaHei';
		-webkit-overflow-scrolling: touch;
		overflow-x: hidden;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		position: relative;

		.Router {
			width: 100%;
			// position: absolute;
			transition: all .377s ease;
			will-change: transform;
			top: 0;
			
			backface-visibility: hidden;
			perspective: 1000;
			overflow-x: hidden;
		}
	}

	.main {
		box-sizing: content-box;
	}

	.mainChild {
		transition: all .1s ease;
		will-change: transform;
		top: 0;
		backface-visibility: hidden;
		perspective: 1000;
	}

	.slide-left-enter,
	.slide-right-leave-active {
		opacity: 0;
		// transform: translate3d(-100%, 0, 0);
	}

	.slide-left-leave-active,
	.slide-right-enter {
		opacity: 1;
		// transform: translate3d(100%, 0, 0);
	}
	
	.audios {
		position: absolute;
		background-image: url('data:image/png;base64,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');
		width: 0.72rem;
		height: 0.72rem;
		top: 0.8rem;
		right: 0.666666rem;
		z-index: 999;
		// transform: translateZ(100px);
		background-size: 100% 100%;
		
		.audiosIm{
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			z-index: 999;
			transform: translateZ(10px);
		}
		
		audio {
			width: 100%;
			height: 100%;
			opacity: 0;
		}
	}
	//音乐的动画
	.animateRotates {
		animation: rotates 3s linear infinite !important;
		-moz-animation: rotates 3s linear infinite !important;
		/* Firefox */
		-webkit-animation: rotates 3s linear infinite !important;
		/* Safari 和 Chrome */
		-o-animation: rotates 3s linear infinite !important;
	}
	@keyframes rotates {
		from {
			transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			/* IE 9 */
			-moz-transform: rotate(0deg);
			/* Firefox */
			-webkit-transform: rotate(0deg);
			/* Safari 和 Chrome */
			-o-transform: rotate(0deg);
		}
	
		to {
			transform: rotate(360deg);
			-ms-transform: rotate(360deg);
			/* IE 9 */
			-moz-transform: rotate(360deg);
			/* Firefox */
			-webkit-transform: rotate(360deg);
			/* Safari 和 Chrome */
			-o-transform: rotate(360deg);
		}
	}
	
	@-moz-keyframes rotates {
		from {
			transform: rotate(0deg);
			-moz-transform: rotate(0deg);
		}
	
		to {
			transform: rotate(360deg);
			-moz-transform: rotate(360deg);
		}
	}
	
	@-webkit-keyframes rotates {
		from {
			transform: rotate(0deg);
			-webkit-transform: rotate(0deg);
		}
	
		to {
			transform: rotate(360deg);
			-webkit-transform: rotate(360deg);
		}
	}
	
	@-o-keyframes rotates {
		from {
			transform: rotate(0deg);
			-o-transform: rotate(0deg);
		}
	
		to {
			transform: rotate(360deg);
			-o-transform: rotate(360deg);
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue